// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-btn[data-v-16bb8fa9] {\n  width: 80%;\n  display: flex;\n  justify-content: flex-end;\n  margin: 0 auto;\n}\n[data-v-16bb8fa9] .el-dialog__footer {\n  border-top: 1px #f5f5f5 solid;\n  padding-top: 15px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
